import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps-box" }
const _hoisted_2 = { class: "step-body my-scroller" }

import { Edit, Picture, Upload, UserFilled } from '@element-plus/icons-vue'
import { ref, onMounted, nextTick, watch, reactive, getCurrentInstance, computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'workFlow',
  props: {
  stepsActive: {
    type: Number,
    default: 1,
  }
},
  emits: ['update:stepsActive'],
  setup(__props, { emit: __emit }) {

const emits = __emit;
let props = __props
let vModelStepsActive = computed({
  get() {
    return props.stepsActive;
  },
  set(value) {
    emits('update:stepsActive', value);
  },
})



return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_steps, {
      active: _unref(vModelStepsActive),
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_step, {
          title: "文案助理",
          icon: _unref(Edit)
        }, null, 8, ["icon"]),
        _createVNode(_component_el_step, {
          title: "演员配置",
          icon: _unref(UserFilled)
        }, null, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})